module.exports = __webpack_public_path__ + "static/media/easy-icon.acbe665d.svg";